var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-list"},[_vm._t("default"),_vm._l((_vm.services),function(item){return _c('service',{key:item.key,attrs:{"icon-url":item.imageUrl}},[_vm._v("\n    "+_vm._s(item.name)+"\n  ")])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }